import ActionType from 'actions/ActionType'

export default (
	state = { anyChanged: false, changedValues: {}, initialFields: {} },
	action,
) => {
	switch (action.type) {
		case ActionType.PREDICTIONS.INGEST_PREDICTION:
			if (action?.intent === 'createSignupForm') {
				return {
					...state,
					anyChanged: true,
				}
			}
			return state
		case ActionType.SignupForm.HANDLE_FORM_VALUE_CHANGE:
			return {
				...state,
				anyChanged: true,
				changedValues: {
					...state.changedValues,
					[action.property]: true,
				},
			}
		case ActionType.SignupForm.FORM_FIELD_REQUIRED_CHANGE:
			return {
				...state,
				anyChanged: true,
			}
		case ActionType.SignupForm.HANDLE_FORM_DRAG:
			return {
				...state,
				anyChanged: true,
			}
		case ActionType.SignupForm.HANDLE_FORM_FIELD_CHANGE:
			return {
				...state,
				anyChanged: true,
			}
		case ActionType.SignupForm.ADD_REQUEST:
			return {
				...state,
				anyChanged: false,
			}
		case ActionType.SignupForm.RECEIVE_FORM:
			if (action.payload) {
				return {
					anyChanged: false,
					changedValues: {},
					initialFields: action.payload.contact_fields.reduce(
						(initialFields, field) => {
							initialFields[field.field_name] = { required: field.required }
							return initialFields
						},
						{ ...state.initialFields },
					),
				}
			}
			return { anyChanged: false, changedValues: {}, initialFields: {} }
		case ActionType.CustomForm.RECEIVE_FORM:
			return { anyChanged: false, changedValues: {}, initialFields: {} }
		case ActionType.SignupForm.UPDATE_SUCCESS:
			return {
				anyChanged: false,
				changedValues: {},
				initialFields: action.payload.contact_fields.reduce(
					(initialFields, field) => {
						initialFields[field.field_name] = { required: field.required }
						return initialFields
					},
					{ ...state.initialFields },
				),
			}
		default:
			return state
	}
}
